import l from "./extends3.mjs";
import * as i from "react";
import { useIsDateDisabled as F } from "./useIsDateDisabled.mjs";
import { useNow as I, useUtils as k } from "./useUtils.mjs";
import { singleItemValueManager as x } from "./valueManagers.mjs";
import { SECTION_TYPE_GRANULARITY as T } from "./getDefaultReferenceDate.mjs";
import N from "./useEventCallback.mjs";
const P = (a, s, r) => (n, e) => {
  switch (e.type) {
    case "changeMonth":
      return l({}, n, {
        slideDirection: e.direction,
        currentMonth: e.newMonth,
        isMonthSwitchingAnimating: !a
      });
    case "finishMonthSwitchingAnimation":
      return l({}, n, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (n.focusedDay != null && e.focusedDay != null && r.isSameDay(e.focusedDay, n.focusedDay))
        return n;
      const h = e.focusedDay != null && !s && !r.isSameMonth(n.currentMonth, e.focusedDay);
      return l({}, n, {
        focusedDay: e.focusedDay,
        isMonthSwitchingAnimating: h && !a && !e.withoutMonthSwitchingAnimation,
        currentMonth: h ? r.startOfMonth(e.focusedDay) : n.currentMonth,
        slideDirection: e.focusedDay != null && r.isAfterDay(e.focusedDay, n.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, z = (a) => {
  const {
    value: s,
    referenceDate: r,
    defaultCalendarMonth: n,
    disableFuture: e,
    disablePast: h,
    disableSwitchToMonthOnDayFocus: y = !1,
    maxDate: w,
    minDate: S,
    onMonthChange: f,
    reduceAnimations: p,
    shouldDisableDate: A,
    timezone: d
  } = a, b = I(d), o = k(), C = i.useRef(P(!!p, y, o)).current, m = i.useMemo(
    () => {
      let t = null;
      return r ? t = r : n && (t = o.startOfMonth(n)), x.getInitialReferenceValue({
        value: s,
        utils: o,
        timezone: d,
        props: a,
        referenceDate: t,
        granularity: T.day
      });
    },
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), [u, D] = i.useReducer(C, {
    isMonthSwitchingAnimating: !1,
    focusedDay: o.isValid(s) ? s : b,
    currentMonth: o.startOfMonth(m),
    slideDirection: "left"
  }), M = i.useCallback((t) => {
    D(l({
      type: "changeMonth"
    }, t)), f && f(t.newMonth);
  }, [f]), R = i.useCallback((t) => {
    const c = t;
    o.isSameMonth(c, u.currentMonth) || M({
      newMonth: o.startOfMonth(c),
      direction: o.isAfterDay(c, u.currentMonth) ? "left" : "right"
    });
  }, [u.currentMonth, M, o]), g = F({
    shouldDisableDate: A,
    minDate: S,
    maxDate: w,
    disableFuture: e,
    disablePast: h,
    timezone: d
  }), O = i.useCallback(() => {
    D({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), E = N((t, c) => {
    g(t) || D({
      type: "changeFocusedDay",
      focusedDay: t,
      withoutMonthSwitchingAnimation: c
    });
  });
  return {
    referenceDate: m,
    calendarState: u,
    changeMonth: R,
    changeFocusedDay: E,
    isDateDisabled: g,
    onMonthSwitchingAnimationEnd: O,
    handleChangeMonth: M
  };
};
export {
  P as createCalendarStateReducer,
  z as useCalendarState
};
//# sourceMappingURL=useCalendarState.mjs.map
